import { defineComponent as _defineComponent } from 'vue'
import {
  SkeletonLoader,
  Grid,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';

export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationLoader',
  setup(__props) {


return { __sfc: true,SkeletonLoader, Grid, LoaderIndicator }
}

})